import {
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
} from '../../../constants/route'

export const ENTITY_TAB_REQUESTS_SUB_TAB_ORDER = [
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
]

export const ENTITY_TAB_REQUESTS_SUB_TAB_TEXT_KEY = {
  [SUBMENU_DEFAULT_VALUE]: 'EntityTabRequests.SubTabAllKey',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'EntityTabRequests.SubTabArchiveKey',
}

export const ENTITY_TAB_REQUESTS_SUB_TAB_QA_NAME = {
  [SUBMENU_DEFAULT_VALUE]: 'entityTabRequestsSubTabAll',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'entityTabRequestsSubTabArchive',
}

export const ENTITY_TAB_REQUESTS_SCALAR_SCOPE_FILTER_KEYS = [
  'for_building_group',
  'for_contractor',
  'staff_member',
]

export const ENTITY_TAB_REQUESTS_FILTER_BAR_ITEMS_PROPS = {
  SaveTemplateButton: null,
  ShareTemplateButton: null,
}

export const ENTITY_TAB_REQUESTS_DEFAULT_QA_NAME = {
  addNew: 'entityTabRequestsAddNew',
  export: 'entityTabRequestsExport',
  table: 'entityTabRequestsTable',
}
